import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { makeStyles, Grid, Typography } from "@material-ui/core";

import { KPIS } from "../constants";
import { ShaDowBox, CardBox } from "../../../components/boxes";
import { Icon, LinearProgress } from "../../../components/base";
import { TwentyYear } from "../../../components/units/TwentyYear";
import { api, requestDateFormat, currencyFormatter, getPercent } from "../../../services";
import UnrealizedImg from "../../../assets/images/dashboard/unrealized.svg";

const useStyles = makeStyles((theme) => ({
  container: {
    flexWrap: "noWrap",
  },
  icon: {
    marginRight: theme.spacing(1.5),
  },
}));

const initialData = {
  per_date: 0,
  per_20y: 0,
};

export const UnrealizedPowerRevenueKPI = ({
  activeKpi,
  setActiveKpi,
  period,
  startDate,
  endDate,
}) => {
  const classes = useStyles();
  const [data, setData] = useState(initialData);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  useEffect(() => {
    const getData = (url) => {
      api.get(url).then((resp) => setData(resp.data));
    };

    const getUrl = (period) => {
      let url = "/praas/v1/dashboard/unrealized-power-revenue/";
      if (period.name === "RANGE" && endDate) {
        url += `?from_date=${requestDateFormat(startDate)}&to_date=${requestDateFormat(endDate)}`;
        getData(url);
      } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
        url += `?date_filter=${period.filter}`;
        getData(url);
      }
    };

    getUrl(period);
  }, [period, startDate, endDate]);

  return (
    <Grid
      id="unrealized-power-revenue-kpi"
      item
      style={{ flex: 1 }}
      onClick={() => setActiveKpi(KPIS.unrealized_power_revenue)}
    >
      <ShaDowBox active={activeKpi === KPIS.unrealized_power_revenue} hoverable>
        <CardBox>
          <Grid className={classes.container} container>
            <Icon root={classes.icon} src={UnrealizedImg} />
            <div>
              <Typography
                color={activeKpi === KPIS.unrealized_power_revenue ? "primary" : undefined}
                variant="h2"
                style={{
                  fontWeight: "bold",
                  color: activeKpi !== KPIS.unrealized_power_revenue ? "#979797" : undefined,
                }}
              >
                {currencyFormatter(data.per_date, currencySymbol)}
              </Typography>
              <Typography>Unrealized Power Revenue</Typography>
            </div>
          </Grid>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={7}>
              <LinearProgress
                active={activeKpi === KPIS.unrealized_power_revenue}
                variant="determinate"
                value={getPercent(data.per_date, data.per_20y)}
              />
            </Grid>
            <Typography align="right">{currencyFormatter(data.per_20y, currencySymbol)}</Typography>
            <TwentyYear />
          </Grid>
        </CardBox>
      </ShaDowBox>
    </Grid>
  );
};
